import { GetCurrentUserQuery } from "@/graphql/generated/graphql";
import { GetCurrentUser } from "@/graphql/queries/GetCurrentUser";
import { useGraphQuery } from "@dashboard/library";
import { UserCurrentUserReturn } from "./useCurrentUser.decl";

/**
 * Hook to get the current user data.
 * @returns an object holding the query state and user's data
 */
export function useCurrentUser(): UserCurrentUserReturn {
  const { data, error, loading } =
    useGraphQuery<GetCurrentUserQuery>(GetCurrentUser);

  return {
    loading,
    error,
    data,
    currentUser: data?.getAgentV2,
  };
}
